import React from 'react';
import JavascriptProgrammingStrictMode from './JavascriptProgrammingStrictMode.jsx';
import JavascriptProgrammingScopes from './JavascriptProgrammingScopes.jsx';
import JavascriptProgrammingHoisting from './JavascriptProgrammingHoisting.jsx';
import JavascriptProgrammingDebugging from './JavascriptProgrammingDebugging.jsx';
import JavascriptProgrammingModules from './JavascriptProgrammingModules.jsx';
import JavascriptProgrammingStyleGuide from './JavascriptProgrammingStyleGuide.jsx';
import JavascriptProgrammingBestPractices from './JavascriptProgrammingBestPractices.jsx';
import JavascriptProgrammingMistakes from './JavascriptProgrammingMistakes.jsx';
import JavascriptProgrammingPerformance from './JavascriptProgrammingPerformance.jsx';

export default function JsProgramming() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Programming</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/programming/strict-mode' className='underline'>JS Strict Mode</a></li>
<li><a href='/javascript/programming/scopes' className='underline'>JS Scopes</a></li>
<li><a href='/javascript/programming/hoisting' className='underline'>JS Hoisting</a></li>
<li><a href='/javascript/programming/debugging' className='underline'>JS Debugging</a></li>
<li><a href='/javascript/programming/modules' className='underline'>JS Modules</a></li>
<li><a href='/javascript/programming/style-guide' className='underline'>JS Style Guide</a></li>
<li><a href='/javascript/programming/best-practices' className='underline'>JS Best Practices</a></li>
<li><a href='/javascript/programming/mistakes' className='underline'>JS Mistakes</a></li>
<li><a href='/javascript/programming/performance' className='underline'>JS Performance</a></li>
      </ul>
    </div>
  );
}
